import React, { FC } from "react"
import { DayPicker } from "react-day-picker"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"

import { classNames } from "../../utils/Helpers"
import { InputProps } from "../../utils/Interfaces"

export const DatePicker: FC<InputProps> = ({
    name,
    value,
    error,
    label,
    disabled,
    required,
    placeHolder,
    dateHandler,
    changeHandler,
}) => {
    placeHolder = placeHolder || (
        label
            ? (label.charAt(0).toUpperCase() + label.slice(1).toLowerCase())
            : (name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
    )

    return (
        <React.Fragment>
            {
                label && (
                    <label htmlFor={name} className="block text-sm leading-6 text-primary-dark dark:text-slate-400 mb-1">{label}</label>
                )
            }

            <div className={classNames(
                disabled ? "bg-gray-100/70" : "bg-white dark:bg-slate-900",
                "w-full rounded-md"
            )}>
                <div className="flex align-middle items-center flex-row mx-auto w-full rounded-lg gap-x-2">
                    <div className="relative flex-grow">
                        <input type="text" name={name} id={name} placeholder={placeHolder} autoComplete="off"
                            className={classNames(
                                error.length > 0 ?
                                    'text-red-900 placeholder:text-red-400 focus:ring-red-600 border border-red-600 focus:outline-red-500' :
                                    'text-primary placeholder:text-stone-400 dark:placeholder:text-slate-400 dark:placeholder-gray-400 dark:text-white focus:border-0 focus:ring-orange-500 focus:outline-orange-500',
                                "text-sm sm:text-sm rounded-md border border-slate-300 dark:border-slate-600 py-1.5 px-2 block w-full dark:bg-gray-700 disabled:cursor-not-allowed disabled:text-slate-400"
                            )} onChange={(e) => changeHandler(e)} disabled={disabled} value={value} onBlur={(e) => dateHandler(e)} required={required} />

                        <div className="absolute inset-y-0 right-1.5 flex items-center w-5 transform -translate-y-0">
                            {
                                error.length > 0 ? (
                                    <span className="fa-duotone text-red-500 fa-circle-exclamation fa-lg"></span>
                                ) : null
                            }
                        </div>
                    </div>

                    <Menu as="div" className="relative flex-none inline-block text-left">
                        <MenuButton aria-disabled={disabled} className={classNames(
                            disabled ? "bg-gray-300/80 text-slate-400" : "bg-slate-300 text-slate-600 dark:bg-slate-500 dark:text-slate-200",
                            "flex-none w-8 h-8 rounded-md flex items-center justify-center align-middle"
                        )}>
                            <i className="fa-light fa-calendar fa-lg"></i>
                        </MenuButton>

                        <MenuItems transition anchor="bottom end" className="absolute w-64 right-0 z-10 mt-1 origin-top-right rounded-md bg-white dark:bg-slate-800 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in flex items-center justify-center">
                            <div className="px-2 py-2">
                                <MenuItem>
                                    {({ close }) => (
                                        <DayPicker
                                            captionLayout="dropdown"
                                            mode="single"
                                            selected={value}
                                            onSelect={(e) => dateHandler(e, close)}
                                        />
                                    )}
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>

            {
                error.length > 0 ? (
                    <span className='invalid-feedback text-xs text-red-600 pl-1 pt-0.5'>
                        {error}
                    </span>
                ) : null
            }
        </React.Fragment>
    )
}